import PopupBase from "@luminecence/composants/PopupBase"
import { css, html } from "lit"
import "@luminecence/composants/ChampAutocompletion"
import "@luminecence/composants/LibelleChamp"
import "@luminecence/composants/BoutonIcone"
import "@luminecence/composants/CaseACocher"

export default class PopupFiltre extends PopupBase {
  static properties = {
    valeur: { type: String },
    nomPokemon: { type: String },
    nomAmi: { type: String },
    estShiny: { type: Boolean },
    estParfait: { type: Boolean },
  }

  static styles = [
    PopupBase.styles,
    css`
    .cases-a-cocher {
      display: flex;
      gap: 1rem;
    }`,
  ]

  constructor() {
    super()
    this.nomPokémon = ""
    this.nomAmi = ""
    this.estShiny = false
    this.estParfait = false
  }

  render() {
    const fonctionApresRecuprerationValeursPossible = (valeurs) => {
      return valeurs.map((pokemon) => pokemon.name)
    }

    return html`
            <div class="conteneur">
                <h1>Filtrer</h1>
                <div class="formulaire">
                    <div class="libelle-champ">
                        <label>nom du pokémon</label>
                        <p-champ-autocompletion .valeur=${this.nomPokémon} .url=${"https://pokebuildapi.fr/api/v1/pokemon"} .placeholder=${"nom du pokémon"} .fonctionApresRecuprerationValeursPossible=${fonctionApresRecuprerationValeursPossible} @evenementChangementValeur=${this.changerNom}> </p-champ-autocompletion>
                    </div>
                    <p-libelle-champ type="text" id-input="nomAmi" .libelle=${"nom de l'ami"} .valeur=${this.nomAmi} @evenementChangerValeurChamp=${this.changerNomAmi}></p-libelle-champ>
                    <div class="cases-a-cocher">
                      <p-case-a-cocher .libelle=${"shiny"} .valeur=${this.estShiny} @evenementChangerValeurChamp=${this.changerEstShiny}></p-case-a-cocher>
                      <p-case-a-cocher .libelle=${"parfait"} .valeur=${this.estParfait} @evenementChangerValeurChamp=${this.changerEstParfait}></p-case-a-cocher>
                    </div>
                </div>
            </div>
            ${this.renderBoutons()}
        `
  }

  renderBoutons() {
    return html`
      <div class="boutons">
        <p-bouton-icone id="bouton-valider" texte="valider" @click=${this.valider}></p-bouton-icone>
        <p-bouton-icone id="supprimer-filtre" texte="supprimer le filtre" @click=${this.supprimerFiltre}></p-bouton-icone>
        <p-bouton-icone id="bouton-annuler" texte="annuler" @click=${this.annuler}></p-bouton-icone>
      </div>
    `
  }

  changerNom(event) {
    this.nomPokémon = event.target.valeur
  }

  changerNomAmi(event) {
    this.nomAmi = event.target.valeur
  }

  changerEstShiny(event) {
    this.estShiny = event.target.coche
  }

  changerEstParfait(event) {
    this.estParfait = event.target.coche
  }

  supprimerFiltre() {
    this.dispatchEvent(new CustomEvent("valider", { detail: { raz: true } }))
    this.fermerPopup()
  }

  valider() {
    this.dispatchEvent(
      new CustomEvent("valider", { detail: { nomPokémon: this.nomPokémon, nomAmi: this.nomAmi, estShiny: this.estShiny, estParfait: this.estParfait } }),
    )
    this.fermerPopup()
  }

  annuler() {
    this.dispatchEvent(new CustomEvent("valider"))
    this.fermerPopup()
  }
}
customElements.define("p-popup-filtre", PopupFiltre)
